import React from 'react';
import TakeControl from '../Home/components/TakeControl';
import TextField from '../../components/TextField/TextField';
import TextArea from '../../components/TextArea/TextArea';

import ASSETS from '../../assets';
import Button from '../../components/Button/Button';

const Contact = () => {
  return (
    <div className=''>
      <div className='w-full lg:min-h-[calc(100vh_-_24px)] rounded-[24px] bg-l-light-grey 2xl:px-[68px] lg:px-12 px-6  flex flex-col lg:pt-[88px] pt-[100px] lg:pb-0 pb-6'>
        <div className='flex-grow flex lg:flex-row flex-col items-center justify-between gap-10'>
          <div className='lg:flex-1 lg:min-w-[350px]'>
            <p className='xl:text-[48px] xl:leading-[72px] md:text-[32px] md:leading-[48px]  text-3xl text-l-primary font-bold max-w-[20ch] '>
              Connect with Legal Avenue
            </p>
            <p className='lg:text-lg text-base text-l-primary font-medium max-w-[45ch] mt-6'>
              Whether you have a question in mind, want to book an appointment,
              or simply want to talk to our team, you can always reach out to
              us.
            </p>
          </div>
          <div className='flex-1'>
            <img src={ASSETS.her02} className='ml-auto' alt='' />
          </div>
        </div>
      </div>
      <div className='lg:px-[68px] md:px-12 px-3 lg:my-[120px] my-12'>
        <p className='lg:text-[40px] lg:leading-[52px] text-3xl leading-[44px] text-l-primary font-bold'>
          Get in Touch with Us
        </p>
        <p className='text-base text-l-primary max-w-[60ch] mt-6'>
          Please make sure to provide your correct Name, Email, and Phone
          Number. Once we get your information, we'll reach out to you in 24
          hours.
        </p>
        <div className='flex items-start lg:flex-row flex-col justify-between gap-10 mt-[72px]'>
          <div className='flex-grow w-full  max-w-[750px] flex flex-col gap-6'>
            <div className='flex items-center gap-[18px]'>
              <p className='lg:text-xl text-base font-medium text-l-primary min-w-[7ch]'>
                Name
              </p>
              <TextField placeholder='Enter Full Name ' />
            </div>
            <div className='flex items-center gap-[18px]'>
              <p className='lg:text-xl text-base font-medium text-l-primary min-w-[7ch]'>
                Email
              </p>
              <TextField placeholder='Enter Email Address' type='email' />
            </div>
            <div className='flex items-center gap-[18px]'>
              <p className='lg:text-xl text-base font-medium text-l-primary min-w-[7ch]'>
                Phone
              </p>
              <TextField placeholder='Enter Number' />
            </div>
            <div className='flex items-start gap-[18px]'>
              <p className='lg:text-xl text-base font-medium text-l-primary min-w-[7ch] pt-3'>
                Message
              </p>
              <TextArea />
            </div>
            <div className='flex items-start gap-[18px]'>
              <p className='lg:text-xl text-base font-medium text-l-primary min-w-[7ch] pt-3'></p>
              <Button label='Submit' rightIcon={ASSETS.arrowRightWhite} />
            </div>
          </div>
          <div>
            <div className='flex items-start gap-6'>
              <div className='size-[56px] grid place-items-center rounded-full bg-l-green'>
                <img src={ASSETS.mail} alt='' />
              </div>
              <div>
                <div className='h-[56px] flex items-center'>
                  <p className='text-l-primary font-medium text-2xl'>
                    info@legalavenue.com
                  </p>
                </div>
                <p className='text-sm text-l-primary max-w-[40ch] pt-2'>
                  Send us your questions or any concerns via email. We will
                  respond to your email{' '}
                  <span className='font-semibold'>within 24 hours.</span>
                </p>
              </div>
            </div>
            <div className='flex items-start gap-6 mt-[54px]'>
              <div className='size-[56px] grid place-items-center rounded-full bg-l-yellow'>
                <img src={ASSETS.phone} alt='' />
              </div>
              <div>
                <div className='h-[56px] flex items-center'>
                  <p className='text-l-primary font-medium text-2xl'>
                    +92 000 7777222
                  </p>
                </div>
                <p className='text-sm text-l-primary max-w-[40ch] pt-2'>
                  Prefer to speak with one of our team members? Feel free to
                  call us in business hours:
                  <br />
                  <br />
                  <span className='font-semibold'>
                    (Monday to Friday | 9:00 AM to 5:00 PM)
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <TakeControl />
      </div>
    </div>
  );
};

export default Contact;
